import { motion } from "framer-motion";
import { XCircle, Briefcase, ArrowRight } from "lucide-react";

export default function ErrorState({ applicationId, onNavigate }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
      className="text-center"
    >
      <h1 className="mb-2 text-3xl font-bold text-gray-900 sm:text-4xl">
        Payment Verification Error
      </h1>

      {applicationId && (
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8 px-2 text-sm font-medium text-gray-600 break-all min-w-0 max-w-full"
        >
          Application ID: <span className="font-mono font-semibold">{applicationId}</span>
        </motion.p>
      )}

      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
        className="flex justify-center mb-6"
      >
        <div className="relative">
          <div className="flex justify-center items-center w-32 h-32 bg-gradient-to-br from-red-500 to-red-700 rounded-full border-4 border-red-300 shadow-xl">
            <XCircle size={64} className="text-white drop-shadow-lg" />
          </div>
          <motion.div
            animate={{ opacity: [0.2, 0.4, 0.2] }}
            transition={{ duration: 2, repeat: Infinity }}
            className="absolute inset-0 bg-red-400 rounded-full"
          />
        </div>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4 }}
        className="mb-2 text-lg font-semibold text-gray-900"
      >
        An error occurred while verifying your payment.
      </motion.p>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="mb-8 text-base text-gray-600"
      >
        Please check your connection or contact support if the issue persists.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
        className="flex flex-col gap-3 justify-center items-center sm:flex-row"
      >
        <motion.button
          onClick={() => (window.location.href = "mailto:support@example.com")}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex gap-2 items-center px-6 py-3 text-sm font-semibold text-red-700 rounded-lg border-2 border-red-300 transition-all bg-red-50/80 hover:bg-red-100 hover:border-red-400"
        >
          <Briefcase size={18} />
          Contact Support Chat
        </motion.button>

        <motion.button
          onClick={() => onNavigate(-1)}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="inline-flex gap-2 items-center px-6 py-3 text-sm font-semibold text-white bg-gradient-to-r from-red-500 to-red-600 rounded-lg shadow-xl transition-all hover:from-red-600 hover:to-red-700 hover:shadow-2xl"
        >
          <ArrowRight size={18} />
          Retry Transaction
        </motion.button>
      </motion.div>
    </motion.div>
  );
}

